import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getUserProfile } from '@dealstack/frontend/shared/dataExchange/services/user.service';
import { PROFILE_ROUTES } from '@dealstack/frontend/shared/components/Profile/Profile';

export const useProfileSidebarMenuController = () => {
	const location = useLocation();
	const currentLocation = useMemo(() => {
		const pathName = location.pathname.split('/').pop();
		return `/${pathName}`;
	}, [location.pathname]);

	const [currentTab, setCurrentTab] = useState(currentLocation);
	const navigate = useNavigate();

	useEffect(() => {
		setCurrentTab(currentLocation);
	}, [location.pathname]);

	const onChangeTabClicked = (newTab: PROFILE_ROUTES) => {
		navigateToProfileTab(newTab);
	};

	const navigateToProfileTab = useCallback((investorProfileRoutePath: PROFILE_ROUTES) => {
		navigate(`/profile${investorProfileRoutePath}`);
	}, []);

	const checkIsTabSelected = useCallback(
		(tab: PROFILE_ROUTES) => {
			return currentTab === tab;
		},
		[currentTab]
	);

	const getUserProfilesRequest = useQuery({
		queryKey: [API_PATHS.USER_PROFILE_GET],
		queryFn: ({ signal }) => getUserProfile(API_PATHS.USER_PROFILE_GET, signal),
	});

	const user = getUserProfilesRequest?.data?.payload;

	const hasVehicleData = !!user?.vehicleData?.corporateNumber && !!user?.vehicleData?.pivName;

	return { currentTab, onChangeTabClicked, checkIsTabSelected, hasVehicleData };
};
